import { Checkbox } from "./Checkbox";
import { useEffect, useState } from "react";
import ShowImages from "./ShowImages";

const SecTableBody = ({ columns, tableData, delRow }) => {
  const [activeIndex, setActiveIndex] = useState("");
  const handleDelete = id => {
    setActiveIndex(id);
    delRow(id);
  };
  useEffect(
    () => {
      const saveData = () => {
        localStorage.setItem("pokedex", JSON.stringify(tableData));
      };
      saveData();
    },
    [activeIndex]
  );
  const showTable = () =>
    tableData.map((data, objIndex) => {
      const index = data["pokedex"];
      return (
        <tr
          className="ui cell row"
          key={index}
          style={data["isCaught"] ? { display: "" } : { display: "none" }}
        >
          {columns.map(({ accessor, tCheck }) => {
            const tContent =
              accessor === "name"
                ? (tCheck = (
                    <div align="center">
                      {data[accessor]}
                      <br />

                      <ShowImages pokeName={data[accessor]} />
                    </div>
                  ))
                : accessor !== "isCaught"
                  ? (tCheck = data[accessor])
                  : (tCheck = (
                      <Checkbox
                        checkStatus={data[accessor]}
                        id={index}
                        index={objIndex}
                        delRow={handleDelete}
                      />
                    ));
            return (
              <td key={accessor} className="ui body cell">
                {tContent}
              </td>
            );
          })}
        </tr>
      );
    });
  return (
    <tbody>
      {showTable()}
    </tbody>
  );
};
export default SecTableBody;
